import { generateURL } from 'utils/helpers';

const utility = {
  vehicleTypes: () => {
    const url = generateURL('/utility/vehicle_types');
    return fetch(url).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to fetch makes'));
      }
      return response.json();
    });
  },
};

export default utility;
